import { SummaryStat } from './SummaryStat';
import { summaryAmount } from '../../../helpers/summaryFormatting';
import { useId, useState } from 'react';

const percent = value => new Intl.NumberFormat('es-PE', {maximumFractionDigits:1}).format(value);

export const ProjectedProfitStat = ({ projects, currency, href = '/projects', scopeLabel = 'Proyectos en proceso' }) => {
    const [expanded, setExpanded] = useState(false);
    const comparisonId = useId();
    const comparable = projects?.margin != null && projects?.target_margin != null;
    const difference = comparable ? Math.round((Number(projects.margin)-Number(projects.target_margin))*10)/10 : null;
    const comparison = difference === 0 ? 'En línea con lo presupuestado.'
        : `${percent(Math.abs(difference))} puntos porcentuales ${difference < 0 ? 'por debajo' : 'por encima'} de lo presupuestado.`;
    return <SummaryStat label="Rentabilidad proyectada" value={summaryAmount(projects?.profit,currency)}
        context={projects ? `${scopeLabel} · margen proyectado ${projects.margin == null ? '—' : percent(projects.margin)} %` : 'Datos no disponibles'}
        href={href}
        description="Ganancia esperada al finalizar los proyectos: ventas netas menos gastos reales netos y costos pendientes por ejecutar. El pendiente suma las diferencias positivas por ítem, sin compensar sobrecostos de otros ítems."
        detail={comparable && <>
            <button type="button" className="p-summary-comparison-toggle" aria-expanded={expanded} aria-controls={comparisonId}
                onClick={() => setExpanded(value => !value)}>{expanded ? 'Ver menos' : 'Ver más'}</button>
            <div id={comparisonId} hidden={!expanded} className="p-summary-comparison">
                <small>Margen presupuestado: {percent(projects.target_margin)} %</small><small>{comparison}</small>
            </div>
        </>}
    />;
};
